export const TOP_LEVEL_PREFIX = '/ar';

//export const TOP_LEVEL_PREFIX = (process.env.NODE_ENV === 'production') ? '/leadgen': '';

export const APPLICATION_URL = "/app/:apptype/preaprobacion";
export const CHAT_URL = "/app/:apptype/completa-tus-datos(-chat)?(-short)?(-form)?";
export const NORMAL_CHAT_URL = '/app/:apptype/completa-tus-datos'
export const PRESTAMO_URL = "/mi-prestamo"
export const REQUESTED_URL = "/monto";
export const UPFRONT_URL = "/anticipo";
export const NOCOLLATERAL_URL = "/sin-propiedad";
export const COLLATERAL_URL = "/propiedad";
export const CAR_URL = "/automovil";
export const COBORROWER_URL = "/cotitulares";
export const INCOME_URL = "/ingresos";
export const PERSONAL_URL = "/personales";
export const PROPUESTA_URL = '/propuesta';
export const SELECTOR_URL = '/seleccionar-prestamo'
export const SIMULATOR_URL = "/simulador";
export const DASHBOARD_URL = '/app/dashboard';

//UW
export const UW_URL = '/app/:apptype/uw';
export const PREAPROBACION_URL = '/preaprobacion';
export const UW_CONTACT_URL = '/contacto';
export const UW_DOCUMENTS_URL = '/documentacion';
export const UW_CHECKING_DATA_URL = '/revision';
export const UW_PREMEETING_URL = '/entrevista-personal';
export const UW_MEETING_URL = '/entrevista-presencial';
export const UW_POST_MEETING_URL = '/envio-de-oferta';
export const UW_CONFIRM_URL = '/propuesta-final';
export const UW_SIGN_URL = '/fecha-de-firma';

// CONTACTO AUTOS
export const CAR_CONTACT_URL = "/contacto-autos";

export const SHORT_URL = '/app/:apptype';
export const SHORT_FORM_URL = '/sprint-leadgen';


export const SIMPLE_CHAT_URL = '/app/:apptype/completa-tus-datos';
export const REDIRECT_URL = "/";

export const AUTH_PATH = '/app/auth(/hd|/sp|)';
export const AUTH_URL = '/app/auth';
export const REGISTER_URL = '/registrate';
export const ACTIVATE_URL = '/activacion/:token/';
export const LOGIN_URL = '/login';
export const LOGOUT = '/app/auth/logout/';
export const FORGOTPASSWORD_URL = '/recupera-contrasena';
export const CONFIRM_FORGOTPASSWORD_URL = '/confirma-contrasena/:token/';
export const CHANGEPASSWORD_URL = '/cambia-contrasena';

export const PROFILE_URL = '/app/profile'

// Non wizard urls
export const HOME_URL = '/';
export const VIDEO_URL = '/app/video';
export const QUESTIONNAIRE_URL = "/app/solicitar-mi-prestamo";

// Managed by bumpversion, don't edit manually
export const CURRENT_VERSION = '6.0.0';

export const GOOGLE_MAPS_API_KEY = "AIzaSyC-TnsgONE8seaxaMFqqlVFso4KczaVXPo";
export const GOOGLE_ANALYTICS_ID = "UA-81057805-1";
export const GOOGLE_OPTIMIZE_ID = "GTM-TF43GZT";

//Social Links
export const AGILIS_VIDEO_ID = "jTzH-jzv-DM";
export const linkTwitter = "https://twitter.com/AgilisPrestamos";
export const linkFacebook = "https://www.facebook.com/Agilis-Pr%C3%A9stamos-Hipotecarios-284819755377661/";
export const linkLinkedin = "https://www.linkedin.com/company/27211492/";

//Partners and Legal
export const linkLCNI = 'https://www.lacomunidadinmobiliaria.com/';
export const linkRemax = 'http://www.remax.com.ar/';
export const linkInterwin = 'http://www.interwin.com.ar/';
export const linkTGLT = 'http://www.tglt.com.ar/';
export const linkCACE = 'http://www.cace.org.ar/';
export const linkAFIP = 'http://qr.afip.gob.ar/?qr=hLcGQpsMKPnNubwGGWZLxQ,,';
export const linkPDP = 'http://www.jus.gob.ar/datos-personales.aspx';
export const linkVeraz = 'https://www.veraz.com.ar/ECOMMERCE/inicio.ecom';
export const linkAGL = 'http://www.aglcapital.com.ar”';
export const linkItau = 'http://itau.com.ar';
export const linkRI = 'http://www.reporteinmobiliario.com.ar/';
export const linkRSE = 'http://www.exporealestate.com.ar/';
export const linkMI = 'http://www.minmobiliario.com.ar/';
export const linkTYC = '/tyc';
export const FORCE_FB_TRACKING = false; // set to true to force FB PIXEL events tracking to work even when not in production

var numeralPoint = { numeral: true, numeralDecimalMark: ',', delimiter: '.' }
var numeral = { numeral: true, delimiter: '' }
var tenDigits = Object.assign({}, numeralPoint, { numeralIntegerScale: 10, numeralDecimalScale: 0 });

export var incomeCleaveOptions = tenDigits;
export var upfrontCleaveOptions = tenDigits;
export var requestedCleaveOptions = tenDigits;
export var declaredValueCleaveOptions = tenDigits;

export var mtsCleaveOptions = Object.assign({}, numeralPoint, { numeralDecimalScale: 2 });
export var postalCodeCleaveOptions = Object.assign({}, numeral, { numeralDecimalScale: 0, numeralIntegerScale: 4 });
export var dniCleaveOptions = Object.assign({}, numeralPoint, { numeralIntegerScale: 8, numeralDecimalScale: 0 });

export var dayInput = { date: true, datePattern: ['d'] };
export var monthInput = { date: true, datePattern: ['m'] };
export var yearInput = { date: true, datePattern: ['Y'] };

export let capture_time = 3000;


export const LAT = -34.67;
export const LNG = -58.4;

// Idle Modal timeout value

export const TIMEOUT_VALUE_MODAL = 40000;

var env_name = require('./env_data.json');
var active_env = require('./env.json')[env_name.ENV_NAME || 'local'];

export const URL_BASE = active_env.API_URL;

export const url = (name, apptype='ce') => {
    apptype = apptype.toLowerCase();
    const URLS = {
        //flows
        'mi-prestamo': `/ar/app/${apptype}/completa-tus-datos/mi-prestamo`,
        'personales': `/ar/app/${apptype}/completa-tus-datos/personales`,
        'ingresos': `/ar/app/${apptype}/completa-tus-datos/ingresos`,
        'cotitulares': `/ar/app/${apptype}/completa-tus-datos/cotitulares`,
        'propiedad': `/ar/app/${apptype}/completa-tus-datos/propiedad`,
        'propuesta': `/ar/app/${apptype}/completa-tus-datos/propuesta`,
        'simulador': `/ar/app/${apptype}/completa-tus-datos/propuesta/simulador`,
        'automovil': `/ar/app/${apptype}/completa-tus-datos/automovil`,
        'preaprobacion': `/ar/app/${apptype}/uw/preaprobacion`,
        'contacto': `/ar/app/${apptype}/uw/contacto`,
        'documentacion': `/ar/app/${apptype}/uw/documentacion`,
        'revision': `/ar/app/${apptype}/uw/revision`,
        //auth
        'login': `/ar/app/auth/login`,
        'registrate': `/ar/app/auth/registrate`,
        'activacion': `/ar/app/auth/registrate/activacion`,
        'recupera-contrasena': `/ar/app/auth/recupera-contrasena`,
        'cambia-contrasena': `/ar/app/auth/cambia-contrasena`,
    }
    return URLS[name]
}
